import { useNavigate } from "react-router-dom";
import Button from "src/components/atomic/Button";
import {
  CASE_MOVED_MODAL_MESSAGE,
  ICaseMovedModalProps
} from "./caseMovedModal.types";

const CaseMovedModal = (props: ICaseMovedModalProps) => {
  const { closeModal } = props;
  const navigate = useNavigate();

  const handleGoToHome = () => {
    navigate("/my-queue");
  };

  const handleCloseModal = () => {
    window.location.reload();
    closeModal();
  };

  return (
    <div>
      <div>{CASE_MOVED_MODAL_MESSAGE}</div>

      <div className="flex justify-end gap-2">
        <Button onClick={handleCloseModal}>Cancel</Button>
        <Button onClick={handleGoToHome}>Go to Home</Button>
      </div>
    </div>
  );
};

export default CaseMovedModal;
